import { render, staticRenderFns } from "./editBargainAct.vue?vue&type=template&id=c9c640b4&scoped=true&"
import script from "./editBargainAct.vue?vue&type=script&lang=js&"
export * from "./editBargainAct.vue?vue&type=script&lang=js&"
import style0 from "./editBargainAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editBargainAct.vue?vue&type=style&index=1&id=c9c640b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c640b4",
  null
  
)

component.options.__file = "editBargainAct.vue"
export default component.exports